import { Link } from 'react-router-dom';
import { Autoria, Marca } from '../ui/base';
import { instalacion } from '@tanteo/compartido/instalacion';
import { EnlacesLegales } from './legal/PaginaLegal';

/**
 * Portada pública: un solo CTA de crear cuenta,
 * "Iniciar sesión" en el header, lenguaje de usuario — cero vocabulario interno
 * (regla en docs/11-branding.md §6).
 */
export function Portada() {
  return (
    <main className="flex min-h-full flex-col" data-e2e="portada">
      <header className="border-border bg-card border-b">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-3">
          <Marca className="text-marca-grande" />
          <Link to="/ingresar" className="text-primary-deep font-bold underline" data-e2e="portada-entrar">
            Iniciar sesión
          </Link>
        </div>
      </header>

      <section className="mx-auto w-full max-w-5xl px-4 py-14">
        <div className="firma-degradado mb-6 h-1.5 w-24 rounded-full" aria-hidden="true" />
        <h1 className="max-w-3xl text-portada font-extrabold">
          Las cuentas claras de tu negocio, todos los días.
        </h1>
        <p className="text-muted mt-4 max-w-2xl text-titulo">
          Registra cada venta, cierra la caja sabiendo si cuadró y ten a la mano en qué se va la plata.
        </p>
        <div className="mt-8">
          <Link
            to="/crear-cuenta"
            data-e2e="portada-crear"
            className="rounded-control bg-primary text-primary-foreground inline-flex min-h-(--alto-boton-principal) items-center px-6 py-3 text-boton-principal font-extrabold hover:opacity-90"
          >
            Crear cuenta
          </Link>
        </div>
      </section>

      <section className="bg-surface/60">
        <div className="mx-auto grid w-full max-w-5xl gap-4 px-4 py-10 sm:grid-cols-3">
          <div className="rounded-card bg-card border-border border p-5">
            <h2 className="font-extrabold">Vende y cobra rápido</h2>
            <p className="text-muted mt-1 text-contenido">
              Registra cada venta con los botones en pantalla o pasando el código de barras del producto, como en un
              supermercado. Cada venta queda guardada con su número y su hora.
            </p>
          </div>
          <div className="rounded-card bg-card border-border border p-5">
            <h2 className="font-extrabold">Cierra la caja sin calculadora</h2>
            <p className="text-muted mt-1 text-contenido">
              Al final del día cuentas la plata, la escribes, y {instalacion.nombre} te dice al instante si la caja cuadró o cuánto
              falta.
            </p>
          </div>
          <div className="rounded-card bg-card border-border border p-5">
            <h2 className="font-extrabold">Tus gastos, anotados en segundos</h2>
            <p className="text-muted mt-1 text-contenido">
              Escanea el código que traen los recibos de tus proveedores y el gasto queda guardado con su fecha y su
              valor. Los demás los escribes tú.
            </p>
          </div>
        </div>
      </section>

      <footer className="border-border text-muted mt-auto border-t">
        <div className="mx-auto w-full max-w-5xl px-4 py-4 text-center text-etiqueta">
          <div className="mb-2">
            <EnlacesLegales />
          </div>
          By CARDAVIL
        </div>
        <Autoria className="pb-4" />
      </footer>
    </main>
  );
}
